import React from 'react';

const Travel: React.FC = () => (
  <div className="Page">
    <p className='title'>Travel</p>
    <p>Travel and accommodation details will be provided here.</p>
  </div>
);

export default Travel;
